import { Controller } from "stimulus"

export default class extends Controller
  initialize: ->
    $(@element).tokenfield
      createTokensOnBlur: true
    $(@element).tokenfield('enable')